
<app-header></app-header>

<main>
    <app-loading></app-loading>
    <app-confirmation></app-confirmation>
    <app-api-error-banner></app-api-error-banner>
    <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
